import React, { useState } from 'react';
import {
    Row,
    Col,
    Divider,
    Input,
    Typography,
    Form,
    Button,
    DatePicker,
    AutoComplete,
    message,
    Select
} from 'antd';
import {
    FaSave
} from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import axios from '../../config/axios';
import rawProvince from '../../utils/province.json';

const gradeList = [
    { key: 'K1', value: 'K1', label: 'อนุบาล 1' },
    { key: 'K2', value: 'K2', label: 'อนุบาล 2' },
    { key: 'K3', value: 'K3', label: 'อนุบาล 3' },
    { key: 'P1', value: 'P1', label: 'ประถมศึกษาปีที่ 1' },
    { key: 'P2', value: 'P2', label: 'ประถมศึกษาปีที่ 2' },
    { key: 'P3', value: 'P3', label: 'ประถมศึกษาปีที่ 3' },
    { key: 'P4', value: 'P4', label: 'ประถมศึกษาปีที่ 4' },
    { key: 'P5', value: 'P5', label: 'ประถมศึกษาปีที่ 5' },
    { key: 'P6', value: 'P6', label: 'ประถมศึกษาปีที่ 6' },
    { key: 'S1', value: 'S1', label: 'มัธยมศึกษาปีที่ 1' },
    { key: 'S2', value: 'S2', label: 'มัธยมศึกษาปีที่ 2' },
    { key: 'S3', value: 'S3', label: 'มัธยมศึกษาปีที่ 3' },
    { key: 'S4', value: 'S4', label: 'มัธยมศึกษาปีที่ 4' },
    { key: 'S5', value: 'S5', label: 'มัธยมศึกษาปีที่ 5' },
    { key: 'S6', value: 'S6', label: 'มัธยมศึกษาปีที่ 6' },
    { key: 'O1', value: 'O1', label: 'บุคคลทั่วไป' },
]
function Create() {
    const redirect = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const [result, setResult] = useState([]);
    const [form] = Form.useForm();

    const { mutate, isLoading } = useMutation({
        mutationFn: (data) => {
            axios
                .post(`/api/students/`, data)
                .then(() => {
                    messageApi.open({
                        type: 'success',
                        content: 'User account has been created.',
                        duration: 1,
                        onClose: () => redirect(`/admin/students`)
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Something went wrong please check you data or contact Admin.',
                    });
                })
        },
    });

    const onFinish = (values) => {
        mutate(values);
    }
    const handleDistrictSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.district.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleAmphoeSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.amphoe.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const handleProvinceSearch = (value) => {
        let res = [];
        res = rawProvince
            .filter(filter => filter.province.includes(value))
            .map(p => `${p.district}/${p.amphoe}/${p.province}/${p.zipcode}`)
        setResult(res);
    };

    const onSelect = info => {
        const splitTambon = info.split('/');
        form.setFieldsValue({
            sub_district: splitTambon[0],
            district: splitTambon[1],
            province: splitTambon[2],
            postalcode: splitTambon[3]
        })
    };

    return (
        <div style={{
            background: '#fff',
        }}>
            {contextHolder}
            <Row justify='space-between' >
                <Col xs={24} md={12} >
                    <Typography.Title level={3}>
                        Add Student
                    </Typography.Title>
                </Col>
                <Divider />
                <Col xs={24}>
                    <Form
                        name="createStudent"
                        layout="vertical"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row>
                            <Col xs={24} md={16}>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="First Name (ภาษาไทย)"
                                            name="fname_th"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Last Name (ภาษาไทย)"
                                            name="lname_th"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Student Phone"
                                            name="phone"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Parent Phone"
                                            name="parent_phone"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="First Name (English)"
                                            name="fname_en"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Last Name (English)"
                                            name="lname_en"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Nick Name"
                                            name="nick_name"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="School"
                                            name="school"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Grade"
                                            name="grade"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Select placeholder="Select grade">
                                                {gradeList.map(item => <Select.Option key={item.key} value={item.value}>{item.label}</Select.Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Gender"
                                            name="gender"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Select placeholder="Select gender">
                                                <Select.Option value="MALE">Male</Select.Option>
                                                <Select.Option value="FEMALE">Female</Select.Option>
                                                <Select.Option value="OTHER">Other</Select.Option>
                                            </Select>
                                        </Form.Item>

                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="ID Card"
                                            name="idcard"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Birthdate"
                                            name="birth_date"
                                        >
                                            <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            name="address"
                                            label="Adress"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Input.TextArea rows={2} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Subdistrict"
                                            name="sub_district"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleDistrictSearch}
                                            >
                                                {result.map((tam) => (
                                                    <AutoComplete.Option key={tam} value={tam}>
                                                        {tam}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="District"
                                            name="district"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleAmphoeSearch}
                                            >
                                                {result.map((amp) => (
                                                    <AutoComplete.Option key={amp} value={amp}>
                                                        {amp}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Province"
                                            name="province"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <AutoComplete
                                                onSelect={onSelect}
                                                onSearch={handleProvinceSearch}
                                            >
                                                {result.map((prov) => (
                                                    <AutoComplete.Option key={prov} value={prov}>
                                                        {prov}
                                                    </AutoComplete.Option>
                                                ))}
                                            </AutoComplete>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Postalcode"
                                            name="postalcode"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Please input data!',
                                                },
                                            ]}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Parent Name (ภาษาไทย)"
                                            name="parent_fname_th"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Parent Lastname (ภาษาไทย)"
                                            name="parent_lname_th"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} >
                                        <Row justify="end">
                                            <Col>
                                                <Form.Item>
                                                    <Button
                                                        type="primary"
                                                        htmlType="submit"
                                                        disabled={isLoading}
                                                        icon={<FaSave />}
                                                        style={{
                                                            textTransform: 'capitalize'
                                                        }}
                                                    >
                                                        save
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default Create